import { render, staticRenderFns } from "./RemovePartModal.vue?vue&type=template&id=4d9679b0&scoped=true&"
import script from "./RemovePartModal.vue?vue&type=script&lang=js&"
export * from "./RemovePartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9679b0",
  null
  
)

export default component.exports